const brand_char_options = ["A","B","C","D","E","F","G","H","J","N","M","O","P","R","S","T","W","X","Y","K","Q","L","U","V","Z","1","2","3","4","5","6","7","8","9"]
const category_char_options = ["A","H","Z","S","K","C","R","P","M","O","F","B","L","T","G","W","D","Y","J","U","E","N"]
const division_char_options = ["W","M","G","B","D","C","N","O","R","U","H","L","K","J","T","V","P","Y","Z","A","E","F","X"]
const pattern_char_options = ["AB", "AN", "CA", "CO", "FS", "FL", "GE", "IN", "JA", "LO", "PA", "OR", "PT", "PD", "PL", "SE", "ST"]
const season_char_options = ["S", "U", "F", "H"]

export {brand_char_options, category_char_options, division_char_options, pattern_char_options, season_char_options}
